import Trainers from "../assets/json/trainers.json";
import { jsonSkills, SkillNames } from "../utils/json";
import { Positions } from "./Player";

type JsonTrainer = typeof Trainers[number];

export enum TrainerTypes {
  INT = "INT",
  STR = "STR",
  MNT = "MNT",
  DEX = "DEX",
  SP = "SP",
  GP = "GP",
}

type ITrainer = Omit<JsonTrainer, "skills" | "position" | "type"> & {
  position: Positions;
  skills: { [key in keyof JsonTrainer["skills"]]: { [key in SkillNames]: number } };
  type: TrainerTypes[];
  level?: number;
  disabled: boolean;
};

export default ITrainer;
